import styles from "./Loading.module.css";
const Loading = () => {
  return (
    <h1 className={styles["loading"]}>
      Loading....
    </h1>
  );
};

export default Loading;
